/**
 * The portal's line icons, in one place.
 *
 * These paths lived inside the dashboard screen, which was fine while the
 * dashboard was the only screen drawing them. Quick actions draws the same
 * six, and a second copy of a search icon is a second thing to change when
 * the stroke weight moves. The navigation keeps its own set, because those
 * are drawn at a different weight for a different job.
 *
 * One 24x24 box, stroked not filled, so every icon sits on the same grid and
 * inherits its colour from whatever it is placed on.
 */

export const GLYPH: Record<string, string> = {
  clinic: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M4 20c0-3.3 3.6-5 8-5s8 1.7 8 5",
  flask: "M9 3v6l-4.5 9A2 2 0 0 0 6.3 21h11.4a2 2 0 0 0 1.8-3L15 9V3M9 3h6",
  calendar: "M4 7h16v13H4zM4 7V5h16v2M9 3v4M15 3v4",
  bell: "M18 9a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7M13.7 20a2 2 0 0 1-3.4 0",
  search: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16M21 21l-4.3-4.3",
  message: "M4 5h16v10H9l-5 4z",
  poster: "M7 3h10v18H7zM10 7h4M10 11h4M10 15h2",
  chart: "M4 20h16M7 20v-7M12 20V6M17 20v-4",
  recall: "M20 12a8 8 0 1 1-2.3-5.6M20 4v4h-4",
  person: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M4 20c0-3.3 3.6-5 8-5s8 1.7 8 5",
  note: "M6 3h9l3 3v15H6zM14 3v4h4M9 12h6M9 16h4",
  tick: "M20 6 9 17l-5-5",
  cross: "M6 6l12 12M18 6 6 18",
  chevron: "m9 5 7 7-7 7",
  arrow: "M5 12h13M12 5.5l6.5 6.5-6.5 6.5",
};

export function Glyph({ name }: { name: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d={GLYPH[name]} />
    </svg>
  );
}
